import { AlertTriangle, Clock } from 'lucide-react';
import React from 'react';

import { cn } from '@/lib/utils';

interface FollowUpReminderProps {
  daysSinceContact: number;
  lastContactedAt: string | null;
}

export const FollowUpReminder: React.FC<FollowUpReminderProps> = ({
  daysSinceContact,
  lastContactedAt,
}) => {
  const isUrgent = daysSinceContact >= 14;

  const formatLastContact = (timestamp: string | null) => {
    if (!timestamp) return 'Never';
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
  };

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-2 px-3 py-2 text-xs font-semibold border-t',
        isUrgent
          ? 'bg-red-50 text-red-700 border-red-100'
          : 'bg-amber-50 text-amber-700 border-amber-100',
      )}
    >
      <div className="flex items-center gap-2">
        {isUrgent ? (
          <AlertTriangle className="h-3.5 w-3.5 flex-shrink-0" />
        ) : (
          <Clock className="h-3.5 w-3.5 flex-shrink-0" />
        )}
        <span>
          {daysSinceContact === 0 ? (
            'No contact with client yet'
          ) : (
            <>
              <span className="font-bold">{daysSinceContact} days</span> since
              last contact
              {lastContactedAt && ` (${formatLastContact(lastContactedAt)})`}
            </>
          )}
        </span>
      </div>
      {/* CTA placeholder for future follow-up template quick-fill */}
    </div>
  );
};

export default FollowUpReminder;
